import { render, staticRenderFns } from "./ProjectAccountsDetails.vue?vue&type=template&id=3a7c7968&"
import script from "./ProjectAccountsDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectAccountsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports